import cn from 'classnames';
import React from 'react';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  formik: any;
  required?: boolean;
  disabled?: boolean;
  placeholder?: string;
  type?: string;
  onChangeFormatter?: (value: string) => string; // optional formatting before setting value
  onValueChange?: (value: string) => void; // optional external callback
  className?: string;
}

const FormikInputField = ({
  name,
  label,
  formik,
  required,
  disabled,
  placeholder,
  type = 'text',
  onChangeFormatter,
  onValueChange,
  className = '',
  ...rest
}: Props) => {
  const error = formik.touched[name] && formik.errors[name];
  const value = formik.values[name] ?? '';

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let val = e.target.value;
    if (onChangeFormatter) val = onChangeFormatter(val);
    formik.setFieldValue(name, val);
    onValueChange?.(val);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    formik.handleBlur(e);
  };

  return (
    <div className="mt-2 mb-1 w-full">
      {/* Label */}
      <label
        htmlFor={name}
        className="block mb-2 text-sm font-medium text-gray-700"
      >
        {label} {required && <span className="ml-1 text-red-600"> * </span>}
      </label>

      {/* Input */}
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={handleChange}
        onBlur={handleBlur}
        className={cn(
          'w-full px-3 py-2.5 pr-10 pl-3  border-[1px] text-sm border-gray-400 rounded-lg bg-white appearance-none cursor-pointer transition-colors duration-200 focus:outline-none focus:ring-2  focus:border-transparent placeholder:text-sm',
          {
            'border-red-500 focus:ring-red-500': error,
            'bg-gray-100 pointer-events-none opacity-60': disabled,
          },
          className,
        )}
        {...rest}
      />

      {/* Error */}
      {error && (
        <div className="mt-1 text-sm text-red-600">{formik.errors[name]}</div>
      )}
    </div>
  );
};

export default FormikInputField;
